import type { ReactNode } from "react";
import { useState } from "react";
import PhantomButton from "../PhantomButton";
import styles from "./ReadMore.module.css";

interface Props {
  children: ReactNode;
  onExpand: () => void;
}

function noop() {
  // noop
}

export default function ReadMore({ onExpand = noop, children }: Props) {
  const [state, setState] = useState({
    collapsed: true,
  });

  const { collapsed } = state;

  const maxHeight = collapsed ? 140 : "auto";
  const storyClass = collapsed
    ? styles.ReadContent
    : `${styles.ReadContent} ${styles.ReadOpen}`;

  function handleExpand() {
    setState({ collapsed: false });
    onExpand();
  }

  function handleCollapse() {
    setState({ collapsed: true });
  }

  return (
    <div className={storyClass}>
      <div className={styles.ReadContentContainer} style={{ maxHeight }}>
        {children}
      </div>
      <div className={styles.ReadMore}>
        {collapsed ? (
          <PhantomButton onClick={handleExpand}>Read more</PhantomButton>
        ) : (
          <PhantomButton onClick={handleCollapse}>Read less</PhantomButton>
        )}
      </div>
    </div>
  );
}
